import React from "react";
import AddUserModal from "../../common/addUserModal";
import { createCoOwner, updateCoOwner } from "../../../services/co-owner.service";
import { coOwnerMessages } from "../../../constants/message.constant";

type CoOwnerData = {
  id?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  street?: string;
  city?: string;
  state?: string;
  zipcode?: string;
};

type AddCoOwnerModalProps = {
  open: boolean;
  handleClose: (action?: string) => void;
  userId: string;
  editMode?: boolean;
  coOwnerData?: CoOwnerData;
};

const AddCoOwnerModal = ({
  open,
  handleClose,
  userId,
  editMode = false,
  coOwnerData,
}: AddCoOwnerModalProps) => {
  return (
    <AddUserModal
      open={open}
      handleClose={handleClose}
      businessId={userId}
      editMode={editMode}
      userData={coOwnerData}
      title="Co-owner"
      createUser={createCoOwner}
      updateUser={updateCoOwner}
      successMessages={{
        add: coOwnerMessages.addCoOwner,
        edit: coOwnerMessages.editCoOwner,
      }}
    />
  );
};

export default AddCoOwnerModal;
